import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "single-project"
}
const _hoisted_2 = { class: "row gx-5 gy-3" }
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "img-side" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "text-side" }
const _hoisted_8 = { class: "mini-title" }
const _hoisted_9 = { key: 0 }

import { TProject } from '@/types';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Project',
  props: {
    project: null
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (__props.project)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: `https://myplusplus.com/img/${__props.project.image}`,
                alt: ""
              }, null, 8, _hoisted_5)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h2", _hoisted_8, _toDisplayString(__props.project.name), 1),
              _createElementVNode("p", null, _toDisplayString(__props.project.description), 1),
              (__props.project.listItems)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _createTextVNode(_toDisplayString(__props.project.listTitle) + " ", 1),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.project.listItems, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.name
                        }, _toDisplayString(item.name), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})